import React from 'react'
import { CSS, styled } from '../../lib/stitches'

const imgCache = {
  __cache: {},
  read(src) {
    if (!this.__cache[src]) {
      this.__cache[src] = new Promise((resolve) => {
        const img = new Image()
        img.onload = () => {
          this.__cache[src] = true
          resolve(this.__cache[src])
        }
        img.src = src
      }).then((img) => {
        this.__cache[src] = true
      })
    }
    if (this.__cache[src] instanceof Promise) {
      throw this.__cache[src]
    }
    return this.__cache[src]
  }
}

const StyledSuspenseImage = styled('img')

interface Props {
  src: string
  alt: string
  css?: CSS
}

const SuspenseImage: React.FC<Props> = ({ src, alt, css, ...rest }) => {
  imgCache.read(src)

  return <StyledSuspenseImage src={src} alt={alt} css={css} {...rest} />
}

export default SuspenseImage
